import { Box } from "@mui/material";
import { type GridColDef } from "@mui/x-data-grid";

import { type EvaluationStatus } from "./EvaluationStatus.data";

export const evaluationStatusColumns: GridColDef<EvaluationStatus>[] = [
  {
    field: "status",
    headerName: "Status",
    width: 130,
  },
  {
    field: "definition",
    headerName: "Definition",
    flex: 1,
    minWidth: 200,
    renderCell: ({ value }) => <Box sx={{ py: 1 }}>{value}</Box>,
  },
  {
    field: "initiation",
    headerName: "Initiation",
    flex: 1,
    minWidth: 200,
    renderCell: ({ value }) => <Box sx={{ py: 1 }}>{value}</Box>,
  },
  {
    field: "description",
    headerName: "Description",
    flex: 2,
    minWidth: 350,
    renderCell: ({ value }) => <Box sx={{ py: 1 }}>{value}</Box>,
  },
  {
    field: "timeline",
    headerName: "Timeline",
    width: 250,
  },
  {
    field: "point",
    headerName: "Point",
    width: 90,
    align: "center",
    headerAlign: "center",
  },
];
